import { useState } from 'react';
import { Card, Button } from 'react-bootstrap';
import { t } from '../../services/translationService';
import { OrderForm, OrderFormRow } from '../shared/OrderForm';
import { AddToCartRequestItem, CartItemResponse, addItemsToCart } from '../../services/CartService';
import { setCartSize } from '../../redux/reducers/cartSlice.reducer';
import { useDispatch } from 'react-redux';
import NotificationClass from '../../typescript/classes/NotificationClass';
import { NotificationTypes } from "../../typescript/enums/enums";
import { setLoader } from '../../redux/reducers/loaderSlice.reducer';
import { useErrorHandler } from '../../hooks/useErrorHandler';


export const QuickOrder = () => {

  const dispatch = useDispatch();
  const handleError = useErrorHandler();

  const [rows, setRows] = useState<OrderFormRow[]>([
    {
      catalogEntryCode: '',
      quantity: undefined,
      distributors: [],
      selectedDistributorShortName: '',
      title: '',
      reference: '',
    },
  ]);

  const clearForm = () => {
    setRows([
      {
        catalogEntryCode: '',
        quantity: undefined,
        distributors: [],
        selectedDistributorShortName: '',
        title: '',
        reference: '',
      },
    ]);
  }

  const [canAddToCart, setCanAddToCart] = useState(false);

  const createQuickOrder = async () => {
    dispatch(setLoader(true));

    const items: AddToCartRequestItem[] = rows
      .filter((row) => !!row.catalogEntryCode || !!row.quantity || !!row.reference) // Filters out empty rows.
      .map((row): AddToCartRequestItem => ({
        catalogEntryCode: row.catalogEntryCode,
        includeInOrder: true,
        quantity: row.quantity,
        reference: row.reference,
        selectedDistributorShortName: row.selectedDistributorShortName
      }));


    await addItemsToCart(items)
      .then((response) => {
        clearForm();

        // update size on cart badge
        dispatch(setCartSize(response
          .map((item: CartItemResponse) => item.quantity)
          .reduce((previousValue: number, currentValue: number) => previousValue + currentValue, 0)));

        NotificationClass.createNotification({
          type: NotificationTypes.Success,
          message: t('itemsAddedToCart')
        });
      })
      .catch((error) => {
        // Handle error using the centralized handleError function
        handleError(error);
      })
      .finally(() => {
        // Ensure loader is hidden regardless of success or error
        dispatch(setLoader(false));
      });
  }

  return (
    <>
      <Card className="nopadding">
        <Card.Header className="py-4 border-bottom-0">
          <p className="text-muted">
            {t('quickOrderInstructions')}
          </p>
        </Card.Header>
        <Card.Body>
          <OrderForm rows={rows} setRows={setRows} isValid={setCanAddToCart} />
        </Card.Body>
        <Card.Footer>
          <Button className={canAddToCart ? undefined : "disabled"} onClick={() => createQuickOrder()}>
            {t('addAll')}
          </Button>
        </Card.Footer>
      </Card>
    </>
  );
};
